module.exports = __webpack_public_path__ + "img/solar.80e229d1.svg";